export const SceneType = {
  Loading: 'loading',
  Playing: 'playing',
  HoleComplete: 'hole_complete',
  Interstitial: 'interstitial',
  SkipPrompt: 'skip_prompt',
  EndGame: 'end_game',
} as const;

export type SceneType = (typeof SceneType)[keyof typeof SceneType];
